export default __webpack_public_path__ + "static/media/5、首页电解质水.9fd91cb2.jpg";